<app-select [class.include-comparator]="lessThanOrEqualTo() || greaterThanOrEqualTo()" [displayMode]="isMobile() ? 'iconOnly' : displayMode()"
  [class.prefix-and-text]="!isMobile() && displayMode() === 'prefixAndText'" [class.text-only]="!isMobile() && displayMode() === 'textOnly'"
  [disabled]="disabled()" [(ngModel)]="internalModel" (selectedValueChange)="onModelChange($event)">
  <app-option [value]="BaseTypeTier.Basic" [text]="'Basic'" [gearTier]="BaseTypeTier.Basic" [eq]="lessThanOrEqualTo()" [gte]="greaterThanOrEqualTo()">
  </app-option>
  <app-option [value]="BaseTypeTier.Advanced" [text]="'Adv.'" [gearTier]="BaseTypeTier.Advanced" [lte]="lessThanOrEqualTo()" [gte]="greaterThanOrEqualTo()">
  </app-option>
  <app-option [value]="BaseTypeTier.Expert" [text]="'Expert'" [gearTier]="BaseTypeTier.Expert" [lte]="lessThanOrEqualTo()" [gte]="greaterThanOrEqualTo()">
  </app-option>
  <app-option [value]="BaseTypeTier.Elite" [text]="'Elite'" [gearTier]="BaseTypeTier.Elite" [lte]="lessThanOrEqualTo()" [gte]="greaterThanOrEqualTo()">
  </app-option>
  <app-option [value]="BaseTypeTier.Master" [text]="'Master'" [gearTier]="BaseTypeTier.Master" [lte]="lessThanOrEqualTo()" [eq]="greaterThanOrEqualTo()">
  </app-option>
</app-select>
